export const theme = {
  textFont: "Poppins",
  background_white: "#FFFFFF",
  background_footer: "#F5F2F0",
  background_grey: "#FBFBFB",
  text_black: "#333333",
  link_color: "#2D7FF9",
};
